import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SectionLabel } from "../components/SectionLabel";

const CHAIN = ["Strategy", "Design", "Print", "Fabricate", "Install"];

export default function Story() {
  return (
    <section
      id="story"
      data-testid="brand-story-section"
      className="relative scroll-mt-20 overflow-hidden bg-ink"
    >
      <span
        className="pointer-events-none absolute -top-6 right-0 hidden select-none font-display text-[11rem] font-extrabold uppercase leading-none text-stroke lg:block"
        aria-hidden="true"
      >
        INTACT
      </span>
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 py-24 sm:px-6 lg:grid-cols-12 lg:gap-8 lg:px-8 lg:py-36">
        <div className="lg:col-span-5">
          <Reveal>
            <SectionLabel index="CH.02">The Idea</SectionLabel>
          </Reveal>
          <Reveal delay={0.1}>
            <h2
              data-testid="story-title"
              className="mt-8 font-display text-3xl font-extrabold uppercase leading-[1.12] tracking-tight text-paper sm:text-5xl sm:leading-[1.08]"
            >
              The idea should <span className="text-acid">survive</span> the build.
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <Reveal delay={0.15}>
            <p className="text-base leading-relaxed text-fog sm:text-lg">
              Most ambitious projects get passed from a creative agency to a printer, then to a
              fabricator, then to an installer. Every handoff weakens the idea.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="mt-6 text-base leading-relaxed text-paper/90 sm:text-lg">
              Triple O keeps it intact. Strategy, design, large-format production, fabrication and
              installation move as one connected process—so the finished environment carries the
              same energy as the original concept.
            </p>
          </Reveal>
          <Reveal delay={0.35}>
            <ul className="mt-12 flex flex-wrap items-center gap-x-3 gap-y-3 border-t border-white/10 pt-8">
              {CHAIN.map((step, i) => (
                <li key={step} className="flex items-center gap-3">
                  <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-paper/70">
                    {step}
                  </span>
                  {i < CHAIN.length - 1 && (
                    <ArrowRight className="h-3.5 w-3.5 text-acid" aria-hidden="true" />
                  )}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
